import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-159f6454"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer-details-page" }
const _hoisted_2 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_3 = { class: "card-body customer-breadcrumb" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Лавлагаа ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Зээлдэгчийн мэдээлэл")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left me-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Буцах ")
const _hoisted_9 = { class: "row g-10" }
const _hoisted_10 = { class: "col-lg-12" }
const _hoisted_11 = { class: "card shadow" }
const _hoisted_12 = { class: "card-title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-user fs-5 me-3",
  style: {"color":"black"}
}, null, -1))
const _hoisted_14 = {
  class: "section-toggle",
  type: "button"
}
const _hoisted_15 = { class: "card-body" }
const _hoisted_16 = { class: "row g-10" }
const _hoisted_17 = {
  key: 0,
  class: "text-hover-inverse-white bg-hover-white"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fw-bolder" }, "Ерөнхий мэдээлэл", -1))
const _hoisted_20 = { class: "table table-hover table-rounded table-striped border gy-3 gs-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Иргэний дугаар:", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Регистрийн дугаар:", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Иргэний нэр:", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Эцгийн нэр:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Монгол улсын иргэн эсэх:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Ургийн овог:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Төрсөн огноо:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Утас:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Цахим шуудан:", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Гэр бүлийн гишүүдийн тоо:", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Үүнээс ажил эрхэлдэггүй гишүүдийн тоо:", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Татвар төлөгчийн дугаар:", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fw-bolder" }, "Хаягийн мэдээлэл", -1))
const _hoisted_34 = { class: "table table-hover table-rounded table-striped border gy-3 gs-3" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Хаяг дэлгэрэнгүй", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Аймаг, хотын нэр", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Аймаг, хотын код", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Сум, дүүрэгийн нэр", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Сум, дүүрэгийн код", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Баг, хорооны нэр", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Баг, хорооны код", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Гудамжны нэр", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Хорооллын нэр", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Хотхоны нэр", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Байрны нэр", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "зипкод", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fw-bolder" }, "Ажил эрхлэлт", -1))
const _hoisted_48 = { class: "table table-hover table-rounded table-striped border gy-3 gs-3" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Ажил эрхэлдэг эсэх:", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Албан тушаал", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Ажилладаг байгууллагын нэр", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Ажилладаг байгууллагын хаяг", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Ажилладаг байгууллагын утас", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Ажилладаг байгууллагын цахим шуудан", -1))
const _hoisted_55 = { key: 1 }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fw-bolder" }, "Ерөнхий мэдээлэл", -1))
const _hoisted_57 = { class: "table table-hover table-rounded table-striped border gy-3 gs-3" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Регистрийн дугаар:", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Улсын бүртгэлийн дугаар:", -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Байгууллагын нэр:", -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Хуулийн статус:", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Монгол байгууллага эсэх:", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Байгууллагдсан огноо:", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Хувьцаа эзэмшигч иргэн:", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Хувьцаа эзэмшигч байгууллага:", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Утас:", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Цахим шуудан:", -1))
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Ажилчдын тоо:", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Үнэлгээ хийсэн газар:", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Үнэлгээ:", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fw-bolder" }, "Хаягийн мэдээлэл", -1))
const _hoisted_72 = { class: "table table-hover table-rounded table-striped border gy-3 gs-3" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Хаяг дэлгэрэнгүй", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Аймаг, хотын нэр", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Аймаг, хотын код", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Сум, дүүрэгийн нэр", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Сум, дүүрэгийн код", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Баг, хорооны нэр", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Баг, хорооны код", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Гудамжны нэр", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Хорооллын нэр", -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Хотхоны нэр", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Байрны нэр", -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "зипкод", -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fw-bolder" }, "Гүйцэтгэх удирдлагын мэдээлэл", -1))
const _hoisted_86 = { class: "table table-hover table-rounded table-striped border gy-3 gs-3" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Гүйцэтгэх удирдлагын иргэний дугаар", -1))
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Гүйцэтгэх удирдлагын регистрийн дугаар", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Гүйцэтгэх удирдлагын нэр", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Гүйцэтгэх удирдлагын эцгийн нэр", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Гүйцэтгэх удирдлагын ургийн овог", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Гадаад иргэн эсэх", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Гүйцэтгэх удирдлагын гэрийн хаяг", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Гүйцэтгэх удирдлагын утасны дугаар", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Гүйцэтгэх удирдлагын цахим шуудан", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator border-4 my-5" }, null, -1))
const _hoisted_97 = { class: "customer-table-toolbar" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mb-1" }, "Хүснэгтийн мэдээлэл"),
  /*#__PURE__*/_createElementVNode("span", null, "Зээл, шугам, холбогдох этгээд, барьцааны бүх хүснэгтээс хайна.")
], -1))
const _hoisted_99 = { class: "row g-10" }
const _hoisted_100 = { class: "col-lg-12" }
const _hoisted_101 = { class: "card shadow" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-list-alt fs-5 me-3",
    style: {"color":"black"}
  }),
  /*#__PURE__*/_createElementVNode("b", null, "Үүргийн талаарх мэдээлэл")
], -1))
const _hoisted_103 = {
  class: "section-toggle",
  type: "button"
}
const _hoisted_104 = { class: "card-body" }
const _hoisted_105 = {
  key: 0,
  class: "row g-10"
}
const _hoisted_106 = ["onClick"]
const _hoisted_107 = /*#__PURE__*/_createTextVNode(" Нээх ")
const _hoisted_108 = { key: 0 }
const _hoisted_109 = {
  key: 1,
  class: "text-hover-inverse-white bg-hover-white"
}
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator border-4 my-5" }, null, -1))
const _hoisted_111 = { class: "row g-10" }
const _hoisted_112 = { class: "col-lg-12" }
const _hoisted_113 = { class: "card shadow" }
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-list-alt fs-5 me-3",
    style: {"color":"black"}
  }),
  /*#__PURE__*/_createElementVNode("b", null, "Зээлийн шугамын эрхийн мэдээлэл")
], -1))
const _hoisted_115 = {
  class: "section-toggle",
  type: "button"
}
const _hoisted_116 = { class: "card-body" }
const _hoisted_117 = {
  key: 0,
  class: "row g-10"
}
const _hoisted_118 = /*#__PURE__*/_createTextVNode(" Нээх ")
const _hoisted_119 = { class: "badge badge-light-info" }
const _hoisted_120 = {
  key: 1,
  class: "text-hover-inverse-white bg-hover-white"
}
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator border-4 my-5" }, null, -1))
const _hoisted_122 = { class: "row g-10" }
const _hoisted_123 = { class: "col-lg-12" }
const _hoisted_124 = { class: "card shadow" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-list-alt fs-5 me-3",
    style: {"color":"black"}
  }),
  /*#__PURE__*/_createElementVNode("b", null, "Холбогдох этгээд")
], -1))
const _hoisted_126 = {
  class: "section-toggle",
  type: "button"
}
const _hoisted_127 = { class: "card-body" }
const _hoisted_128 = {
  key: 0,
  class: "row g-10"
}
const _hoisted_129 = {
  key: 1,
  class: "text-hover-inverse-white bg-hover-white"
}
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator border-4 my-5" }, null, -1))
const _hoisted_131 = { class: "row g-10" }
const _hoisted_132 = { class: "col-lg-12" }
const _hoisted_133 = { class: "card shadow" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-list-alt fs-5 me-3",
    style: {"color":"black"}
  }),
  /*#__PURE__*/_createElementVNode("b", null, "Барьцаа хөрөнгийн мэдээлэл")
], -1))
const _hoisted_135 = {
  class: "section-toggle",
  type: "button"
}
const _hoisted_136 = { class: "card-body" }
const _hoisted_137 = {
  key: 0,
  class: "row g-10"
}
const _hoisted_138 = ["onClick"]
const _hoisted_139 = {
  key: 1,
  class: "text-hover-inverse-white bg-hover-white"
}
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator border-4 my-5" }, null, -1))
const _hoisted_141 = { class: "row g-10" }
const _hoisted_142 = { class: "col-lg-12" }
const _hoisted_143 = { class: "card shadow" }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-list-alt fs-5 me-3",
    style: {"color":"black"}
  }),
  /*#__PURE__*/_createElementVNode("b", null, "Шугамын барьцаа хөрөнгийн мэдээлэл")
], -1))
const _hoisted_145 = {
  class: "section-toggle",
  type: "button"
}
const _hoisted_146 = { class: "card-body" }
const _hoisted_147 = {
  key: 0,
  class: "row g-10"
}
const _hoisted_148 = ["onClick"]
const _hoisted_149 = { class: "badge badge-light-info" }
const _hoisted_150 = {
  key: 1,
  class: "text-hover-inverse-white bg-hover-white"
}
const _hoisted_151 = {
  id: "loanTransactions",
  "aria-hidden": "true",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_152 = { class: "modal-dialog modal-dialog-centered mw-1000px details-modal" }
const _hoisted_153 = { class: "modal-content" }
const _hoisted_154 = { class: "modal-header" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Зээлийн график", -1))
const _hoisted_156 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_157 = { class: "svg-icon svg-icon-1" }
const _hoisted_158 = { class: "modal-body" }
const _hoisted_159 = { class: "modal-table-toolbar" }
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Хуваарь, төлөлтийн мэдээлэл"),
  /*#__PURE__*/_createElementVNode("span", null, "Огноо, дүн, үлдэгдэл болон бусад утгаар хайна.")
], -1))
const _hoisted_161 = { class: "row g-10" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Хуваарь", -1))
const _hoisted_163 = { class: "row g-10" }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Төлөлт", -1))
const _hoisted_165 = {
  id: "loanCollaterals",
  "aria-hidden": "true",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_166 = { class: "modal-dialog modal-dialog-centered mw-1000px details-modal" }
const _hoisted_167 = { class: "modal-content" }
const _hoisted_168 = { class: "modal-header" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Барьцаа хөрөнгийн эзэмшигчид"),
  /*#__PURE__*/_createElementVNode("span", null, "Барьцаатай холбоотой эзэмшигчийн мэдээлэл")
], -1))
const _hoisted_170 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_171 = { class: "svg-icon svg-icon-1" }
const _hoisted_172 = { class: "modal-body" }
const _hoisted_173 = { class: "modal-table-toolbar" }
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Эзэмшигчид"),
  /*#__PURE__*/_createElementVNode("span", null, "CIN, РД, нэр болон огноогоор хайна.")
], -1))
const _hoisted_175 = { class: "row g-10" }
const _hoisted_176 = {
  id: "lineCollaterals",
  "aria-hidden": "true",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_177 = { class: "modal-dialog modal-dialog-centered mw-1000px details-modal" }
const _hoisted_178 = { class: "modal-content" }
const _hoisted_179 = { class: "modal-header" }
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Шугамын барьцаа хөрөнгийн эзэмшигчид"),
  /*#__PURE__*/_createElementVNode("span", null, "Зээлийн шугамтай холбоотой эзэмшигчийн мэдээлэл")
], -1))
const _hoisted_181 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_182 = { class: "svg-icon svg-icon-1" }
const _hoisted_183 = { class: "modal-body" }
const _hoisted_184 = { class: "modal-table-toolbar" }
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Шугамын барьцааны эзэмшигчид"),
  /*#__PURE__*/_createElementVNode("span", null, "CIN, РД, нэр болон огноогоор хайна.")
], -1))
const _hoisted_186 = { class: "row g-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/reference' } }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          size: "mini",
          type: "info",
          plain: "",
          onClick: _ctx.goBack
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            class: "card-header collapsible-header",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSection('profile')))
          }, [
            _createElementVNode("h3", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("b", null, "Зээлдэгчийн мэдээлэл ~ " + _toDisplayString(_ctx.moment(String(_ctx.customer.lastUpdateDate)).format(
                    "YYYY/MM/DD HH:MM:SS"
                  )) + " ~", 1)
            ]),
            _createElementVNode("button", _hoisted_14, [
              _createElementVNode("i", {
                class: _normalizeClass(
                  _ctx.expandedSections.profile
                    ? 'fas fa-chevron-up'
                    : 'fas fa-chevron-down'
                )
              }, null, 2)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (this.dataLoading)
                ? (_openBlock(), _createBlock(_component_el_skeleton, {
                    key: 0,
                    rows: 5,
                    animated: ""
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (this.customerDetailsNotFound)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Зээлдэгчийн дэлгэрэнгүй мэдээлэл олдсонгүй. "))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (this.isCitizen)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _hoisted_19,
                                _createElementVNode("table", _hoisted_20, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_21,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customer?.identityNo), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_22,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customer?.stateRegisterNo), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_23,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customer?.customerName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_24,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customer?.lastName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_25,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customer.isForeign === 0 ? "Тийм" : "Үгүй"), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_26,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.familyName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_27,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.moment(_ctx.customerDetails?.birthDate).format(
                                  "YYYY/MM/DD"
                                )), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_28,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.phone), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_29,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.email), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_30,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.familyNumofMembers), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_31,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.familyNumofUnemployed), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_32,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.taxNumber), 1)
                                    ])
                                  ])
                                ]),
                                _hoisted_33,
                                _createElementVNode("table", _hoisted_34, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_35,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressFull), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_36,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressAimagCityName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_37,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressAimagCityCode), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_38,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressSoumDistrictName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_39,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressSoumDistrictCode), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_40,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressBagKhorooName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_41,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressBagKhorooCode), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_42,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressStreetName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_43,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressRegionName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_44,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressTownName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_45,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressApartmentName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_46,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressZipcode), 1)
                                    ])
                                  ])
                                ]),
                                _hoisted_47,
                                _createElementVNode("table", _hoisted_48, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_49,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails.isEmployed === 1
                                  ? "Тийм"
                                  : "Үгүй"), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_50,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.jobPosition), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_51,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.jobName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_52,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.jobAddress), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_53,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.jobPhone), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_54,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.jobMail), 1)
                                    ])
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                _hoisted_56,
                                _createElementVNode("table", _hoisted_57, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_58,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customer?.identityNo), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_59,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customer?.stateRegisterNo), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_60,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customer?.customerName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_61,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.requiredData?.find(item => {
                                  return (
                                    item?.annexName === "annex_1" &&
                                    item?.categoryCode ==
                                      _ctx.customerDetails?.orgCompanyType
                                  );
                                })?.categoryName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_62,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customer.isForeign === 0 ? "Тийм" : "Үгүй"), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_63,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.moment(_ctx.customerDetails?.birthDate).format(
                                  "YYYY/MM/DD"
                                )), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_64,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customer?.numofShareholderCustomers), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_65,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customer?.numofShareholderOrgs), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_66,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.phone), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_67,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.email), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_68,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.orgNumofEmployee), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_69,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.requiredData?.find(item => {
                                  return (
                                    item?.annexName === "annex_1" &&
                                    item?.categoryCode ==
                                      _ctx.customerDetails?.orgAgency
                                  );
                                })?.categoryName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_70,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.orgRating), 1)
                                    ])
                                  ])
                                ]),
                                _hoisted_71,
                                _createElementVNode("table", _hoisted_72, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_73,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressFull), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_74,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressAimagCityName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_75,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressAimagCityCode), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_76,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressSoumDistrictName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_77,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressSoumDistrictCode), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_78,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressBagKhorooName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_79,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressBagKhorooCode), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_80,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressStreetName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_81,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressRegionName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_82,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressTownName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_83,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressApartmentName), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_84,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.addressZipcode), 1)
                                    ])
                                  ])
                                ]),
                                _hoisted_85,
                                _createElementVNode("table", _hoisted_86, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _hoisted_87,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.ceoCivilId), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_88,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.ceoRegnum), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_89,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.ceoFirstname), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_90,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.ceoLastname), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_91,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.ceoFamilyname), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_92,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails.ceoIsforeign === 1
                                  ? "Тийм"
                                  : "Үгүй"), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_93,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.ceoAddress), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_94,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.ceoPhone), 1)
                                    ]),
                                    _createElementVNode("tr", null, [
                                      _hoisted_95,
                                      _createElementVNode("td", null, _toDisplayString(_ctx.customerDetails?.ceoEmail), 1)
                                    ])
                                  ])
                                ])
                              ]))
                        ], 64))
                  ], 64))
            ])
          ], 512), [
            [_vShow, _ctx.expandedSections.profile]
          ])
        ])
      ])
    ]),
    _hoisted_96,
    _createElementVNode("div", _hoisted_97, [
      _hoisted_98,
      _createVNode(_component_el_input, {
        modelValue: _ctx.tableSearch,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tableSearch) = $event)),
        clearable: "",
        placeholder: "Хүснэгтээс хайх...",
        "prefix-icon": "el-icon-search",
        size: "small"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_99, [
      _createElementVNode("div", _hoisted_100, [
        _createElementVNode("div", _hoisted_101, [
          _createElementVNode("div", {
            class: "card-header collapsible-header",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleSection('loans')))
          }, [
            _hoisted_102,
            _createElementVNode("button", _hoisted_103, [
              _createElementVNode("i", {
                class: _normalizeClass(
                  _ctx.expandedSections.loans
                    ? 'fas fa-chevron-up'
                    : 'fas fa-chevron-down'
                )
              }, null, 2)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_104, [
            (
                this.role.includes('ROLE_MORE_TLOAN') ||
                  this.role.includes('ROLE_ADMIN')
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    "cell-style": { textAlign: 'center' },
                    data: _ctx.filteredRows('loanInformation'),
                    "empty-text": this.emptyText,
                    "header-cell-style": { textAlign: 'center' },
                    border: "",
                    "element-loading-text": "Өгөгдөл татаж байна...",
                    size: "mini",
                    style: {"width":"100%","margin-top":"20px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "Зээлийн дугаар",
                        prop: "loanCode"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("span", {
                            class: "customized-link-span",
                            "data-bs-target": "#loanTransactions",
                            "data-bs-toggle": "modal",
                            onClick: ($event: any) => (_ctx.getLoanTransactions(scope.row.loanCode))
                          }, _toDisplayString(scope.row.loanCode), 9, _hoisted_106)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        align: "center",
                        fixed: "right",
                        label: "Дэлгэрэнгүй",
                        width: "115"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_button, {
                            size: "mini",
                            type: "primary",
                            plain: "",
                            onClick: ($event: any) => (_ctx.getLoanDetails(scope.row, 'loan'))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_107
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Үүргийн төрөл",
                        prop: "obligationType",
                        width: "150"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", 
                          scope.row.obligationType === 'Зээлийн шугамын зээл'
                            ? 'badge-light-warning'
                            : 'badge-light-primary'
                        ])
                          }, _toDisplayString(scope.row.obligationType), 3)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Холбогдох шугам",
                        prop: "parentCode",
                        width: "140"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Төрөл",
                        "min-width": "150"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.loanTypeName) + " ", 1),
                          (scope.row.subLoanTypeName)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_108, " - " + _toDisplayString(scope.row.subLoanTypeName), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Валют",
                        prop: "currency",
                        width: "80"
                      }),
                      _createVNode(_component_el_table_column, {
                        formatter: _ctx.$filters.formatPrice,
                        label: "Олгосон хэмжээ",
                        prop: "amountLcy",
                        sortable: "",
                        width: "130"
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        label: "Хүү (%)",
                        prop: "interestRate",
                        width: "90"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Олгосон огноо",
                        prop: "starteddate",
                        width: "120"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Төлөгдөх огноо",
                        prop: "expdate",
                        width: "120"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Төлөгдсөн огноо",
                        prop: "paiddate",
                        width: "120"
                      }),
                      _createVNode(_component_el_table_column, {
                        formatter: _ctx.$filters.formatPrice,
                        label: "Үлдэгдэл",
                        prop: "balanceLcy",
                        sortable: "",
                        width: "130"
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        label: "Ангилал",
                        prop: "loanClassName",
                        "min-width": "130"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Барьцааны төрөл",
                        prop: "collSubName",
                        "min-width": "170"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Барьцааны УБ дугаар",
                        prop: "collRegNum",
                        "min-width": "150"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Олгосон байгууллага",
                        prop: "orgName",
                        "min-width": "180"
                      }),
                      false
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_el_table_column, {
                              label: "Гэрээний дугаар",
                              prop: "loanContractNo"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Гэрээ хийсэн огноо",
                              prop: "loanContractDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Олгосон байгууллага",
                              prop: "providerRegnum"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Төрөл",
                              prop: "loanType"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName === "annex_11" &&
                                item?.categoryCode ==
                                  scope.row.loanType?.substring(0, 1) &&
                                item?.subCategoryCode ==
                                  scope.row.loanType?.substring(1)
                              );
                            })?.categoryName) + " - " + _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName === "annex_11" &&
                                item?.categoryCode ==
                                  scope.row.loanType?.substring(0, 1) &&
                                item?.subCategoryCode ==
                                  scope.row.loanType?.substring(1)
                              );
                            })?.subCategoryName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Ангилал",
                              prop: "loanClass"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName === "annex_10" &&
                                item.categoryCode == scope.row.loanClass
                              );
                            })?.categoryName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              formatter: _ctx.$filters.formatPrice,
                              label: "Олгосон хэмжээ LCY",
                              prop: "amountLcy",
                              sortable: ""
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              formatter: _ctx.$filters.formatPrice,
                              label: "Олгосон хэмжээ FCY",
                              prop: "amountFcy",
                              sortable: ""
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              formatter: _ctx.$filters.formatPrice,
                              label: "Үлдэгдэл LCY",
                              prop: "balanceLcy",
                              sortable: ""
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              formatter: _ctx.$filters.formatPrice,
                              label: "Үлдэгдэл FCY",
                              prop: "balanceFcy",
                              sortable: ""
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              formatter: _ctx.$filters.formatPrice,
                              label: "Хүүгийн үлдэгдэл LCY",
                              prop: "interestBalanceLcy",
                              sortable: ""
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              formatter: _ctx.$filters.formatPrice,
                              label: "Хүүгийн үлдэгдэл FCY",
                              prop: "interestBalanceFcy",
                              sortable: ""
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              formatter: _ctx.$filters.formatPrice,
                              label: "Нэмэгдсэн хүүгийн үлдэгдэл LCY",
                              prop: "additionalInterestBalanceLcy",
                              sortable: ""
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              formatter: _ctx.$filters.formatPrice,
                              label: "Нэмэгдсэн хүүгийн үлдэгдэл FCY",
                              prop: "additionalInterestBalanceFcy",
                              sortable: ""
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              label: "Валют",
                              prop: "currency",
                              sortable: ""
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Валютын ханш",
                              prop: "currencyRate",
                              sortable: ""
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Зээлийн үүсэл",
                              prop: "loanProvenance"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName === "annex_5" &&
                                item.categoryCode == scope.row.loanProvenance
                              );
                            })?.categoryName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Bond market",
                              prop: "bondMarket"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Num of bonds",
                              prop: "numofBonds"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Bond unit price",
                              prop: "bondUnitPrice"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Олгосон огноо",
                              prop: "starteddate",
                              sortable: ""
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Дуусах огноо",
                              prop: "expdate",
                              sortable: ""
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Төлөгдсөн огноо",
                              prop: "paiddate",
                              sortable: ""
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Зээлийн төлөв",
                              prop: "status"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName === "annex_6" &&
                                item.categoryCode == scope.row.status
                              );
                            })?.categoryName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Үүргийг хэрхэн шийдвэрлэсэн",
                              prop: "decideStatus"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName === "annex_7" &&
                                item.categoryCode == scope.row.decideStatus
                              );
                            })?.categoryName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Зээлийн зориулалт",
                              prop: "sector"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName === "annex_9" &&
                                item?.categoryCode ==
                                  scope.row.sector?.substring(0, 1) &&
                                item?.subCategoryCode ==
                                  scope.row.sector?.substring(1)
                              );
                            })?.categoryName) + " - " + _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName === "annex_9" &&
                                item?.categoryCode ==
                                  scope.row.sector?.substring(0, 1) &&
                                item?.subCategoryCode ==
                                  scope.row.sector?.substring(1)
                              );
                            })?.subCategoryName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Зээлийн хүү",
                              prop: "interestRate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Зээлийн нэмэгдсэн хүү",
                              prop: "additionalInterestRate"
                            }),
                            _createVNode(_component_el_table_column, {
                              formatter: _ctx.$filters.formatPrice,
                              label: "Зээлийн шимэтгэл дүн",
                              prop: "commission"
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              formatter: _ctx.$filters.formatPrice,
                              label: "Зээлийн хураамжийн дүн",
                              prop: "fee"
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              label: "Зээлийн шугамын гэрээний дугаар",
                              prop: "loanlineContractNo",
                              sortable: ""
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Тайлбар",
                              prop: "description"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Үлдэгдэлт өөрчлөлт орсон огноо",
                              prop: "balanceChangedDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Зээл төлөлтийн хэлбэр",
                              prop: "scheduleType"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName === "annex_12" &&
                                item.categoryCode == scope.row.scheduleType
                              );
                            })?.categoryName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Зээлийн график шинэчлэгдсэн шалтгаан",
                              prop: "scheduleChangeReason"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Үүссэн огноо",
                              prop: "createdDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Сүүлд өөрчлөлт оруулсан огноо",
                              prop: "lastUpdateDate"
                            })
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["data", "empty-text"])), [
                    [_directive_loading, _ctx.dataLoading]
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_109, " Зээлдэгчийн үүргийн талаарх мэдээлэл харах эрхгүй байна. "))
          ], 512), [
            [_vShow, _ctx.expandedSections.loans]
          ])
        ])
      ])
    ]),
    _hoisted_110,
    _createElementVNode("div", _hoisted_111, [
      _createElementVNode("div", _hoisted_112, [
        _createElementVNode("div", _hoisted_113, [
          _createElementVNode("div", {
            class: "card-header collapsible-header",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleSection('loanlines')))
          }, [
            _hoisted_114,
            _createElementVNode("button", _hoisted_115, [
              _createElementVNode("i", {
                class: _normalizeClass(
                  _ctx.expandedSections.loanlines
                    ? 'fas fa-chevron-up'
                    : 'fas fa-chevron-down'
                )
              }, null, 2)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_116, [
            (
                this.role.includes('ROLE_MORE_TLOAN') ||
                  this.role.includes('ROLE_ADMIN')
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    "cell-style": { textAlign: 'center' },
                    data: _ctx.filteredRows('loanlineInformation'),
                    "empty-text": this.emptyText,
                    "header-cell-style": { textAlign: 'center' },
                    border: "",
                    "element-loading-text": "Өгөгдөл татаж байна...",
                    size: "mini",
                    style: {"width":"100%","margin-top":"20px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "Зээлийн шугамын дугаар",
                        prop: "loanlineCode"
                      }),
                      _createVNode(_component_el_table_column, {
                        align: "center",
                        fixed: "right",
                        label: "Дэлгэрэнгүй",
                        width: "115"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_button, {
                            size: "mini",
                            type: "primary",
                            plain: "",
                            onClick: ($event: any) => (_ctx.getLoanDetails(scope.row, 'loanline'))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_118
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Үүргийн төрөл",
                        prop: "obligationType",
                        width: "140"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("span", _hoisted_119, _toDisplayString(scope.row.obligationType), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Төрөл",
                        prop: "loanlineTypeName",
                        "min-width": "150"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Валют",
                        prop: "currency",
                        width: "80"
                      }),
                      _createVNode(_component_el_table_column, {
                        formatter: _ctx.$filters.formatPrice,
                        label: "Олгосон хэмжээ",
                        prop: "amountLcy",
                        sortable: "",
                        width: "130"
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        label: "Хүү (%)",
                        prop: "interestRate",
                        width: "90"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Олгосон огноо",
                        prop: "starteddate",
                        width: "120"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Төлөгдөх огноо",
                        prop: "expdate",
                        width: "120"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Төлөгдсөн огноо",
                        prop: "paiddate",
                        width: "120"
                      }),
                      _createVNode(_component_el_table_column, {
                        formatter: _ctx.$filters.formatPrice,
                        label: "Үлдэгдэл",
                        prop: "balanceLcy",
                        sortable: "",
                        width: "130"
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        label: "Хамаарах зээлийн ангилал",
                        prop: "childLoanClassName",
                        "min-width": "150"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Барьцааны төрөл",
                        prop: "collSubName",
                        "min-width": "170"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Барьцааны УБ дугаар",
                        prop: "collRegNum",
                        "min-width": "150"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Олгосон байгууллага",
                        prop: "orgName",
                        "min-width": "180"
                      }),
                      false
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_el_table_column, {
                              label: "Гэрээний дугаар",
                              prop: "loanlineContractNo"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Гэрээ хийсэн огноо",
                              prop: "loanlineContractDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Олгосон байгууллага",
                              prop: "providerRegnum"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Төрөл",
                              prop: "loanlineType"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName === "annex_13" &&
                                item?.categoryCode == scope.row?.loanlineType
                              );
                            })?.categoryName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              formatter: _ctx.$filters.formatPrice,
                              label: "Олгосон хэмжээ LCY",
                              prop: "amountLcy",
                              sortable: ""
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              formatter: _ctx.$filters.formatPrice,
                              label: "Олгосон хэмжээ FCY",
                              prop: "amountFcy",
                              sortable: ""
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              formatter: _ctx.$filters.formatPrice,
                              label: "Үлдэгдэл LCY",
                              prop: "balanceLcy",
                              sortable: ""
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              formatter: _ctx.$filters.formatPrice,
                              label: "Үлдэгдэл FCY",
                              prop: "balanceFcy",
                              sortable: ""
                            }, null, 8, ["formatter"]),
                            _createVNode(_component_el_table_column, {
                              label: "Олгосон огноо",
                              prop: "starteddate",
                              sortable: ""
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Дуусах огноо",
                              prop: "expdate",
                              sortable: ""
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Төлөгдсөн огноо",
                              prop: "paiddate",
                              sortable: ""
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Валют",
                              prop: "currency"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Валютын ханш",
                              prop: "currencyRate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Зориулалт",
                              prop: "sector"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName === "annex_9" &&
                                item?.categoryCode ==
                                  scope.row.sector?.substring(0, 1) &&
                                item?.subCategoryCode ==
                                  scope.row.sector?.substring(1)
                              );
                            })?.categoryName) + " - " + _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName === "annex_9" &&
                                item?.categoryCode ==
                                  scope.row.sector?.substring(0, 1) &&
                                item?.subCategoryCode ==
                                  scope.row.sector?.substring(1)
                              );
                            })?.subCategoryName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Зээлийн хүү",
                              prop: "interestRate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Зээлийн нэмэгдсэн хүү",
                              prop: "commitmentInterestRate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Тайлбар",
                              prop: "description"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Үлдэгдэлт өөрчлөлт орсон огноо",
                              prop: "balanceChangedDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Үүссэн огноо",
                              prop: "createdDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Сүүлд өөрчлөлт оруулсан огноо",
                              prop: "lastUpdateDate"
                            })
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["data", "empty-text"])), [
                    [_directive_loading, _ctx.dataLoading]
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_120, " Мэдээлэл харах эрхгүй байна. "))
          ], 512), [
            [_vShow, _ctx.expandedSections.loanlines]
          ])
        ])
      ])
    ]),
    _hoisted_121,
    _createElementVNode("div", _hoisted_122, [
      _createElementVNode("div", _hoisted_123, [
        _createElementVNode("div", _hoisted_124, [
          _createElementVNode("div", {
            class: "card-header collapsible-header",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleSection('relations')))
          }, [
            _hoisted_125,
            _createElementVNode("button", _hoisted_126, [
              _createElementVNode("i", {
                class: _normalizeClass(
                  _ctx.expandedSections.relations
                    ? 'fas fa-chevron-up'
                    : 'fas fa-chevron-down'
                )
              }, null, 2)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_127, [
            (
                this.role.includes('ROLE_MORE_TLOAN') ||
                  this.role.includes('ROLE_ADMIN')
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    "cell-style": { textAlign: 'center' },
                    data: _ctx.filteredRows('customerRelations'),
                    "empty-text": this.emptyText,
                    "header-cell-style": { textAlign: 'center' },
                    border: "",
                    "element-loading-text": "Өгөгдөл татаж байна...",
                    size: "mini",
                    style: {"width":"100%","margin-top":"20px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "Хамаарах үүрэг",
                        prop: "obligationType",
                        width: "150"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", 
                          scope.row.obligationType === 'Зээлийн шугамын зээл'
                            ? 'badge-light-warning'
                            : 'badge-light-primary'
                        ])
                          }, _toDisplayString(scope.row.obligationType), 3)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Зээлийн дугаар",
                        prop: "loanCode",
                        width: "130"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Холбогдох хэлбэр",
                        prop: "relationModeName",
                        "min-width": "130"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Холбогдох төрөл",
                        prop: "relationTypeName",
                        "min-width": "160"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Иргэн эсэх",
                        width: "110"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row?.isCitizen === 1 ? "Иргэн" : "Хуулийн этгээд"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Гадаад эсэх",
                        width: "110"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row?.isForeign === 1 ? "Гадаад" : "Дотоод"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "CIN / РД",
                        prop: "relationIdentityNo",
                        "min-width": "130"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "РД / УБД",
                        prop: "relationStateRegisterNo",
                        "min-width": "130"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Нэр",
                        prop: "relationSubjectName",
                        "min-width": "150"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Овог",
                        prop: "relationLastName",
                        "min-width": "130"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Ургийн овог",
                        prop: "relationFamilyName",
                        "min-width": "130"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Санхүүгийн үүрэгтэй",
                        width: "130"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row?.relationIsFinancial === 1 ? "Тийм" : "Үгүй"), 1)
                        ]),
                        _: 1
                      }),
                      false
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_el_table_column, {
                              label: "Холбогдох хэлбэр",
                              prop: "relationMode"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(scope.row?.relationMode === "annex_3"
                              ? "Зээлдэгчтэй"
                              : scope.row?.relationMode === "annex_4"
                              ? "Зээлдүүлэгчтэй"
                              : "Хувьцаа эзэмшигч"), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Холбогдох төрөл",
                              prop: "relationType"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName == scope.row?.relationMode &&
                                item?.categoryCode == scope.row?.relationType
                              );
                            })?.categoryName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Зээлийн дугаар",
                              prop: "loanCode"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Иргэн эсэх",
                              prop: "isCitizen"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(scope.row?.isCitizen === 1
                              ? "Иргэн"
                              : "Хуулийн этгээд"), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Гадаад эсэх",
                              prop: "isForeign"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(scope.row?.isForeign === 1 ? "Гадаад" : "Дотоод"), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "CIN or Regnum",
                              prop: "relationIdentityNo"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Regnum or State regnum",
                              prop: "relationStateRegisterNo"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Нэр",
                              prop: "relationSubjectName"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Овог",
                              prop: "relationLastName"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Ургийн овог",
                              prop: "relationFamilyName"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Санхүүгийн үүрэг хүлээсэн эсэх",
                              prop: "relationIsFinancial"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(scope.row?.relationIsFinancial === 1
                              ? "Тийм"
                              : "Үгүй"), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Хувьцаа эзэмшигчийн хаяг",
                              prop: "shareholderAddress"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Хувьцаа эзэмшигчийн утас",
                              prop: "shareholderPhone"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Хувьцаа эзэмшигчийн мейл",
                              prop: "shareholderEmail"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Үүссэн огноо",
                              prop: "createdDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Сүүлд өөрчлөлт оруулсан огноо",
                              prop: "lastUpdateDate"
                            })
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["data", "empty-text"])), [
                    [_directive_loading, _ctx.dataLoading]
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_129, " Мэдээлэл харах эрхгүй байна. "))
          ], 512), [
            [_vShow, _ctx.expandedSections.relations]
          ])
        ])
      ])
    ]),
    _hoisted_130,
    _createElementVNode("div", _hoisted_131, [
      _createElementVNode("div", _hoisted_132, [
        _createElementVNode("div", _hoisted_133, [
          _createElementVNode("div", {
            class: "card-header collapsible-header",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleSection('collaterals')))
          }, [
            _hoisted_134,
            _createElementVNode("button", _hoisted_135, [
              _createElementVNode("i", {
                class: _normalizeClass(
                  _ctx.expandedSections.collaterals
                    ? 'fas fa-chevron-up'
                    : 'fas fa-chevron-down'
                )
              }, null, 2)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_136, [
            (
                this.role.includes('ROLE_MORE_MORT_INFO') ||
                  this.role.includes('ROLE_ADMIN')
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    "cell-style": { textAlign: 'center' },
                    data: _ctx.filteredRows('collateralInformation'),
                    "empty-text": this.emptyText,
                    "header-cell-style": { textAlign: 'center' },
                    border: "",
                    "element-loading-text": "Өгөгдөл татаж байна...",
                    size: "mini",
                    style: {"width":"100%","margin-top":"20px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "Барьцаа хөрөнгийн дугаар",
                        prop: "collCode"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("span", {
                            class: "customized-link-span",
                            "data-bs-target": "#loanCollaterals",
                            "data-bs-toggle": "modal",
                            onClick: ($event: any) => (_ctx.getLoanCollaterals(scope.row.collCode))
                          }, _toDisplayString(scope.row.collCode), 9, _hoisted_138)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Хамаарах үүрэг",
                        prop: "obligationType",
                        width: "170"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", 
                          scope.row.obligationType ===
                          'Зээлийн шугамын зээлийн барьцаа'
                            ? 'badge-light-warning'
                            : 'badge-light-primary'
                        ])
                          }, _toDisplayString(scope.row.obligationType), 3)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Хамаарах зээл",
                        prop: "loanCode",
                        width: "130"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Барьцааны төрөл",
                        prop: "collSubName",
                        "min-width": "180"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Барьцааны УБ дугаар",
                        prop: "collRegNum",
                        "min-width": "150"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Үнэлгээ хийсэн огноо",
                        prop: "valuationDate",
                        width: "140"
                      }),
                      _createVNode(_component_el_table_column, {
                        formatter: _ctx.$filters.formatPrice,
                        label: "Барьцааны нийт дүн",
                        prop: "value",
                        sortable: "",
                        width: "140"
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        formatter: _ctx.$filters.formatPrice,
                        label: "Үнийн дээд хязгаар",
                        prop: "maxValue",
                        sortable: "",
                        width: "150"
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        label: "Хаяг",
                        prop: "address",
                        "min-width": "220"
                      }),
                      false
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_el_table_column, {
                              label: "Зээлийн дугаар",
                              prop: "loanCode"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Гэрээний дугаар",
                              prop: "collContractNo"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Дотоод дугаар",
                              prop: "collInternalNo"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Төрөл",
                              prop: "collType"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName == "annex_15" &&
                                item?.categoryCode == scope.row?.collType &&
                                item?.subCategoryCode == scope.row?.collSubType
                              );
                            })?.categoryName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Дэд төрөл",
                              prop: "collSubType"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName == "annex_15" &&
                                item?.categoryCode == scope.row?.collType &&
                                item?.subCategoryCode == scope.row?.collSubType
                              );
                            })?.subCategoryName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Үнэлгээ хийсэн огноо",
                              prop: "valuationDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Барьцааны нийт дүн",
                              prop: "value"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Үнийн дээд хягаар",
                              prop: "maxValue"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Зипкод",
                              prop: "zipcode"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Хаяг",
                              prop: "address"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Үл хөдлөх хөрөнгө эсэх",
                              prop: "isRealEstate"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(scope.row?.isRealEstate === 1 ? "Тийм" : "Үгүй"), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "УБЕГ-т бүртгүүлсэн эсэх",
                              prop: "isStateRegistration"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(scope.row?.isStateRegistration === 1
                              ? "Тийм"
                              : "Үгүй"), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Гэрчилгээний дугаар STATE",
                              prop: "stateCertificateNo"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Улсын бүртгэлийн дугаар STATE",
                              prop: "stateRegNum"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Бүртгэгдсэн огноо STATE",
                              prop: "stateRegisteredDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Барьцаалсан тухай ЭХЭУБГазарт бүртгүүлж баталгаажуулсан огноо STATE",
                              prop: "stateConfirmedDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Гэрчилгээний дугаар OTHER",
                              prop: "otherCertificateNo"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Бүртгэл/Зөвшөөрлийн дугаар OTHER",
                              prop: "otherRegNum"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Бүртгүүлсэн эрх бүхий байгууллагын нэр OTHER",
                              prop: "otherName"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Бүртгэгдсэн/Зөвшөөрөл авсан огноо OTHER",
                              prop: "otherRegisteredDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Үүссэн огноо",
                              prop: "createdDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Сүүлд өөрчлөлт оруулсан огноо",
                              prop: "lastUpdateDate"
                            })
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["data", "empty-text"])), [
                    [_directive_loading, _ctx.dataLoading]
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_139, " Мэдээлэл харах эрхгүй байна. "))
          ], 512), [
            [_vShow, _ctx.expandedSections.collaterals]
          ])
        ])
      ])
    ]),
    _hoisted_140,
    _createElementVNode("div", _hoisted_141, [
      _createElementVNode("div", _hoisted_142, [
        _createElementVNode("div", _hoisted_143, [
          _createElementVNode("div", {
            class: "card-header collapsible-header",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleSection('lineCollaterals')))
          }, [
            _hoisted_144,
            _createElementVNode("button", _hoisted_145, [
              _createElementVNode("i", {
                class: _normalizeClass(
                  _ctx.expandedSections.lineCollaterals
                    ? 'fas fa-chevron-up'
                    : 'fas fa-chevron-down'
                )
              }, null, 2)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_146, [
            (
                this.role.includes('ROLE_MORE_MORT_INFO') ||
                  this.role.includes('ROLE_ADMIN')
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                  _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    "cell-style": { textAlign: 'center' },
                    data: _ctx.filteredRows('collateralLineInformation'),
                    "empty-text": this.emptyText,
                    "header-cell-style": { textAlign: 'center' },
                    border: "",
                    "element-loading-text": "Өгөгдөл татаж байна...",
                    size: "mini",
                    style: {"width":"100%","margin-top":"20px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "Шугамын барьцаа хөрөнгийн дугаар",
                        prop: "collCode"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("span", {
                            class: "customized-link-span",
                            "data-bs-target": "#lineCollaterals",
                            "data-bs-toggle": "modal",
                            onClick: ($event: any) => (_ctx.getLoanLineCollaterals(scope.row.collCode))
                          }, _toDisplayString(scope.row.collCode), 9, _hoisted_148)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Хамаарах үүрэг",
                        prop: "obligationType",
                        width: "170"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("span", _hoisted_149, _toDisplayString(scope.row.obligationType), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Хамаарах зээлийн шугам",
                        prop: "loanlineCode",
                        width: "160"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Барьцааны төрөл",
                        prop: "collSubName",
                        "min-width": "180"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Барьцааны УБ дугаар",
                        prop: "collRegNum",
                        "min-width": "150"
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "Үнэлгээ хийсэн огноо",
                        prop: "valuationDate",
                        width: "140"
                      }),
                      _createVNode(_component_el_table_column, {
                        formatter: _ctx.$filters.formatPrice,
                        label: "Барьцааны нийт дүн",
                        prop: "value",
                        sortable: "",
                        width: "140"
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        formatter: _ctx.$filters.formatPrice,
                        label: "Үнийн дээд хязгаар",
                        prop: "maxValue",
                        sortable: "",
                        width: "150"
                      }, null, 8, ["formatter"]),
                      _createVNode(_component_el_table_column, {
                        label: "Хаяг",
                        prop: "address",
                        "min-width": "220"
                      }),
                      false
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_el_table_column, {
                              label: "Зээлийн шугамын дугаар",
                              prop: "loanlineCode"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Гэрээний дугаар",
                              prop: "collContractNo"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Дотоод дугаар",
                              prop: "collInternalNo"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Төрөл",
                              prop: "collType"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName == "annex_15" &&
                                item?.categoryCode == scope.row?.collType &&
                                item?.subCategoryCode == scope.row?.collSubType
                              );
                            })?.categoryName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Дэд төрөл",
                              prop: "collSubType"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.requiredData?.find(item => {
                              return (
                                item?.annexName == "annex_15" &&
                                item?.categoryCode == scope.row?.collType &&
                                item?.subCategoryCode == scope.row?.collSubType
                              );
                            })?.subCategoryName), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Үнэлгээ хийсэн огноо",
                              prop: "valuationDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Барьцааны нийт дүн",
                              prop: "value"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Үнийн дээд хягаар",
                              prop: "maxValue"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Зипкод",
                              prop: "zipcode"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Хаяг",
                              prop: "address"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Үл хөдлөх хөрөнгө эсэх",
                              prop: "isRealEstate"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(scope.row?.isRealEstate === 1 ? "Тийм" : "Үгүй"), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "УБЕГ-т бүртгүүлсэн эсэх",
                              prop: "isStateRegistration"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", null, _toDisplayString(scope.row?.isStateRegistration === 1
                              ? "Тийм"
                              : "Үгүй"), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Гэрчилгээний дугаар STATE",
                              prop: "stateCertificateNo"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Улсын бүртгэлийн дугаар STATE",
                              prop: "stateRegNum"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Бүртгэгдсэн огноо STATE",
                              prop: "stateRegisteredDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Барьцаалсан тухай ЭХЭУБГазарт бүртгүүлж баталгаажуулсан огноо STATE",
                              prop: "stateConfirmedDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Гэрчилгээний дугаар OTHER",
                              prop: "otherCertificateNo"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Бүртгэл/Зөвшөөрлийн дугаар OTHER",
                              prop: "otherRegNum"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Бүртгүүлсэн эрх бүхий байгууллагын нэр OTHER",
                              prop: "otherName"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Бүртгэгдсэн/Зөвшөөрөл авсан огноо OTHER",
                              prop: "otherRegisteredDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Үүссэн огноо",
                              prop: "createdDate"
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "Сүүлд өөрчлөлт оруулсан огноо",
                              prop: "lastUpdateDate"
                            })
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["data", "empty-text"])), [
                    [_directive_loading, _ctx.dataLoading]
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_150, " Мэдээлэл харах эрхгүй байна. "))
          ], 512), [
            [_vShow, _ctx.expandedSections.lineCollaterals]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_151, [
      _createElementVNode("div", _hoisted_152, [
        _createElementVNode("div", _hoisted_153, [
          _createElementVNode("div", _hoisted_154, [
            _createElementVNode("div", null, [
              _hoisted_155,
              _createElementVNode("span", null, _toDisplayString(_ctx.selectedLoanCode || "Зээлийн дугаар"), 1)
            ]),
            _createElementVNode("div", _hoisted_156, [
              _createElementVNode("span", _hoisted_157, [
                _createVNode(_component_inline_svg, { src: "/web/media/icons/duotone/Navigation/Close.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_158, [
            _createElementVNode("div", _hoisted_159, [
              _hoisted_160,
              _createVNode(_component_el_input, {
                modelValue: _ctx.modalSearch,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modalSearch) = $event)),
                clearable: "",
                placeholder: "Modal дотроос хайх...",
                "prefix-icon": "el-icon-search",
                size: "small"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_161, [
              _hoisted_162,
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                "cell-style": { textAlign: 'center' },
                data: _ctx.filteredModalRows('loanSchedule'),
                "empty-text": this.emptyText,
                "header-cell-style": { textAlign: 'center' },
                border: "",
                "element-loading-text": "Өгөгдөл татаж байна...",
                size: "mini",
                style: {"width":"100%","margin-top":"20px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "Төлөгдөх огноо",
                    prop: "dueDate"
                  }),
                  _createVNode(_component_el_table_column, {
                    formatter: _ctx.$filters.formatPrice,
                    label: "Төлөх дүн",
                    prop: "principal",
                    sortable: ""
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    formatter: _ctx.$filters.formatPrice,
                    label: "Төлөх хүүгийн дүн",
                    prop: "interest",
                    sortable: ""
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    formatter: _ctx.$filters.formatPrice,
                    label: "Бусад нэмэлт төлбөр",
                    prop: "additional",
                    sortable: ""
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    formatter: _ctx.$filters.formatPrice,
                    label: "Төлөлт хийсний дараах үлдэгдэл",
                    prop: "balance",
                    sortable: ""
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    label: "Үүссэн огноо",
                    prop: "createdDate"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Сүүлд өөрчлөлт оруулсан огноо",
                    prop: "lastUpdateDate"
                  })
                ]),
                _: 1
              }, 8, ["data", "empty-text"])), [
                [_directive_loading, _ctx.subDataLoading]
              ])
            ]),
            _createElementVNode("div", _hoisted_163, [
              _hoisted_164,
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                "cell-style": { textAlign: 'center' },
                data: _ctx.filteredModalRows('loanPayment'),
                "empty-text": this.emptyText,
                "header-cell-style": { textAlign: 'center' },
                border: "",
                "element-loading-text": "Өгөгдөл татаж байна...",
                size: "mini",
                style: {"width":"100%","margin-top":"20px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "Төлөгдөх огноо",
                    prop: "dueDate"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Төлсөн огноо",
                    prop: "paidDate"
                  }),
                  _createVNode(_component_el_table_column, {
                    formatter: _ctx.$filters.formatPrice,
                    label: "Төлөх дүн",
                    prop: "principal",
                    sortable: ""
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    formatter: _ctx.$filters.formatPrice,
                    label: "Төлөх хүүгийн дүн",
                    prop: "interest",
                    sortable: ""
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    formatter: _ctx.$filters.formatPrice,
                    label: "Бусад нэмэлт төлбөр",
                    prop: "additional",
                    sortable: ""
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    label: "Үүссэн огноо",
                    prop: "createdDate"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Сүүлд өөрчлөлт оруулсан огноо",
                    prop: "lastUpdateDate"
                  })
                ]),
                _: 1
              }, 8, ["data", "empty-text"])), [
                [_directive_loading, _ctx.subDataLoading]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_165, [
      _createElementVNode("div", _hoisted_166, [
        _createElementVNode("div", _hoisted_167, [
          _createElementVNode("div", _hoisted_168, [
            _hoisted_169,
            _createElementVNode("div", _hoisted_170, [
              _createElementVNode("span", _hoisted_171, [
                _createVNode(_component_inline_svg, { src: "/web/media/icons/duotone/Navigation/Close.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_172, [
            _createElementVNode("div", _hoisted_173, [
              _hoisted_174,
              _createVNode(_component_el_input, {
                modelValue: _ctx.modalSearch,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modalSearch) = $event)),
                clearable: "",
                placeholder: "Эзэмшигчээс хайх...",
                "prefix-icon": "el-icon-search",
                size: "small"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_175, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                "cell-style": { textAlign: 'center' },
                data: _ctx.filteredModalRows('collateralOwners'),
                "empty-text": this.emptyText,
                "header-cell-style": { textAlign: 'center' },
                border: "",
                "element-loading-text": "Өгөгдөл татаж байна...",
                size: "mini",
                style: {"width":"100%","margin-top":"20px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "CIN or REGNUM",
                    prop: "identityNo"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "REGNUM or STATE REGNUM",
                    prop: "stateRegisterNo"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Нэр",
                    prop: "subjectName"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Овог",
                    prop: "lastName"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Ургийн овог",
                    prop: "familyName"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Гадаад иргэн эсэх",
                    prop: "isForeign"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", null, _toDisplayString(scope.row?.isForeign === 1 ? "Тийм" : "Үгүй"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Иргэн эсэх",
                    prop: "isCitizen"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", null, _toDisplayString(scope.row?.isCitizen === 1 ? "Иргэн" : "Хуулийн этгээд"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Үүссэн огноо",
                    prop: "createdDate"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Сүүлд өөрчлөлт оруулсан огноо",
                    prop: "lastUpdateDate"
                  })
                ]),
                _: 1
              }, 8, ["data", "empty-text"])), [
                [_directive_loading, _ctx.subDataLoading]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_176, [
      _createElementVNode("div", _hoisted_177, [
        _createElementVNode("div", _hoisted_178, [
          _createElementVNode("div", _hoisted_179, [
            _hoisted_180,
            _createElementVNode("div", _hoisted_181, [
              _createElementVNode("span", _hoisted_182, [
                _createVNode(_component_inline_svg, { src: "/web/media/icons/duotone/Navigation/Close.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_183, [
            _createElementVNode("div", _hoisted_184, [
              _hoisted_185,
              _createVNode(_component_el_input, {
                modelValue: _ctx.modalSearch,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalSearch) = $event)),
                clearable: "",
                placeholder: "Эзэмшигчээс хайх...",
                "prefix-icon": "el-icon-search",
                size: "small"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_186, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                "cell-style": { textAlign: 'center' },
                data: _ctx.filteredModalRows('collateralLineOwners'),
                "empty-text": this.emptyText,
                "header-cell-style": { textAlign: 'center' },
                border: "",
                "element-loading-text": "Өгөгдөл татаж байна...",
                size: "mini",
                style: {"width":"100%","margin-top":"20px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "CIN or REGNUM",
                    prop: "identityNo"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "REGNUM or STATE REGNUM",
                    prop: "stateRegisterNo"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Нэр",
                    prop: "subjectName"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Овог",
                    prop: "lastName"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Ургийн овог",
                    prop: "familyName"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Гадаад иргэн эсэх",
                    prop: "isForeign"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", null, _toDisplayString(scope.row?.isForeign === 1 ? "Тийм" : "Үгүй"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Иргэн эсэх",
                    prop: "isCitizen"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", null, _toDisplayString(scope.row?.isCitizen === 1 ? "Иргэн" : "Хуулийн этгээд"), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Үүссэн огноо",
                    prop: "createdDate"
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "Сүүлд өөрчлөлт оруулсан огноо",
                    prop: "lastUpdateDate"
                  })
                ]),
                _: 1
              }, 8, ["data", "empty-text"])), [
                [_directive_loading, _ctx.subDataLoading]
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}